import PermissionRoute from 'components/PermissionRoute';
import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import NotFound from 'scenes/NotFound';
import { AddBankAccount } from 'v2/components/Pages/AddBankAccount';
import { BankDetails } from 'v2/components/Pages/BankDetails';
import PaymentMethods from 'v2/components/Pages/PaymentMethods';
import Edit from 'v2/components/Pages/Profile/Edit';
import withPartnerOnly from 'v2/components/Shared/withPartnerOnly';

const Profile = () => {
  const base = '/producer/profile';

  const PartnerOnlyPermissionRoute = withPartnerOnly(PermissionRoute);

  return (
    <Switch>
      <Redirect exact to={`${base}/edit`} path={base} />
      <PermissionRoute action='no-access-control-permission' path={`${base}/edit`} component={Edit} />
      <PartnerOnlyPermissionRoute action='no-access-control-permission' path={`${base}/bankdata`} component={BankDetails} />
      <PermissionRoute action='no-access-control-permission' path={`${base}/payment`} component={PaymentMethods} />
      <PermissionRoute action='no-access-control-permission' path={`${base}/add-bank-account`} component={AddBankAccount} />
      <Route path='*' component={NotFound} />
    </Switch>
  );
};
export default Profile;
